// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Ocorrencias_DeleteResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for delete() /ocorrencias/delete
 * Proxy to occurrences-service delete endpoint.
 *
 * The Go service returns an opaque success indicator; we coerce it to
 * a boolean in the controller so the wire shape is deterministic.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type Ocorrencias_DeleteResponseDados = boolean;

export type Ocorrencias_DeleteResponse = ApiResponse<Ocorrencias_DeleteResponseDados>;

registerResponseContract('Ocorrencias_DeleteResponse', {})
